import React from "react";
import HeaderPage from "./HeaderPage";
import FooterPages from "./FooterPages";

type LayoutProps = {
  title: string;
  children: React.ReactNode;
};
function Layout(props: LayoutProps) {
  const lang = localStorage.getItem("Lang");
  return (
    <div
      className={` mx-auto ${
        lang === "ar" ? "font-cairo" : "font-montserrat"
      }`}
    >
      <title>{props.title}</title>
      <HeaderPage />
      {props.children}
      <FooterPages />
    </div>
  );
}

export default Layout;
